import { render } from "./COIAddressTable.vue?vue&type=template&id=641069c1&scoped=true"
import script from "./COIAddressTable.vue?vue&type=script&lang=js"
export * from "./COIAddressTable.vue?vue&type=script&lang=js"

import "./COIAddressTable.vue?vue&type=style&index=0&id=641069c1&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641069c1"]])

export default __exports__